import { getUserStore } from "../store/store";
import { mutatorAction } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";

export const setPriorityViewEnteredTimestampMutator: (mailboxInfo: MailboxInfo, timestamp: number | undefined) => void = mutatorAction("setPriorityViewEnteredTimestampMutator", (mailboxInfo: MailboxInfo, timestamp: number | undefined): void => {
    const store = getUserStore(mailboxInfo);
    store.priorityViewEnteredTimestamp = timestamp;
});
